(() => {
  const deferFn = () => {
    const parser: DOMParser = new DOMParser();

    const deferLinks = (parsedDocument: Document) => {
      const linkElement: HTMLLinkElement = document.getElementsByTagName('link')[0];
      let html: string = parsedDocument.documentElement.innerHTML || parsedDocument.documentElement.textContent;

      if (html.indexOf('&lt;') > -1 || html.indexOf('&gt;') > -1) {
        html = html.replace(/&lt;/gi, '<').replace(/&gt;/g, '>');
      }

      linkElement.insertAdjacentHTML('beforebegin', html);
    };

    const deferScripts = (parsedDocument: Document) => {
      const head: HTMLHeadElement = document.getElementsByTagName('head')[0];
      const nodes: HTMLScriptElement[] = [].slice.call(parsedDocument.documentElement.childNodes);

      for (const script of nodes) {
        if ((script.tagName || '').toLowerCase() !== 'script') {
          continue;
        }

        const dtoScript: HTMLScriptElement = document.createElement('script');
        dtoScript.type = 'text/javascript';
        dtoScript.defer = true;
        dtoScript.async = true;
        dtoScript.setAttribute('src', script.getAttribute('src'));
        head.insertBefore(dtoScript, head.firstChild);
      }
    };

    const deferredElements: NodeListOf<HTMLElement> = document.querySelectorAll('noscript[defer]');
    Array.prototype.forEach.call(deferredElements, (deferredElement: HTMLElement) => {
      const innerHtml: string = (deferredElement.innerHTML || '').trim().replace('\n', '');
      const html: string = (deferredElement.innerHTML || '').trim().replace('\n', '');

      if (innerHtml === '') {
        return;
      }

      const parsedDocument: Document = parser.parseFromString(html, 'text/html');
      const deferType: string = (deferredElement.getAttribute('defer') || '').toLowerCase();

      switch (deferType) {
        case 'scripts':
          deferScripts(parsedDocument);
          break;

        case 'links':
        default:
          deferLinks(parsedDocument);
          break;
      }

      deferredElement.parentNode.removeChild(deferredElement);
    });
  };

  const raf: (callback: FrameRequestCallback) => number =
    requestAnimationFrame ||
    (window as any).mozRequestAnimationFrame ||
    webkitRequestAnimationFrame ||
    (window as any).msRequestAnimationFrame;

  if (raf) {
    raf(deferFn);
  } else {
    window.addEventListener('load', deferFn);
  }
})();
